var path = 'jangl/jangl-page-done/template.html';
var html = "<form name=done novalidate> <h2>Done!</h2> <hr/> <div class=well ng-bind-html=$ctrl.parent.doneCopy></div> </form> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/jangl/jangl-page-done/template.html
// module id = 381
// module chunks = 0